<script setup lang="ts">
import { VProgressCircular } from 'vuetify/components';

withDefaults(
    defineProps<{
        size?: number | string;
        width?: number | string;
        indeterminate?: boolean;
        color?: string;
    }>(),
    {
        size: 20,
        width: 2,
        indeterminate: false,
        color: 'primary',
    },
);

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VProgressCircular
        v-bind="$attrs"
        :size="size"
        :width="width"
        :indeterminate="indeterminate"
        :color="color"
        class="b-progress-circular"
    >
        <slot />
    </VProgressCircular>
</template>
